<template>
  <div class="section-press">
    <div class="press-container">
      <h2 class="press-heading">언론 속의 서티라이프</h2>

      <div class="press-cards">
        <div
          v-for="(article, idx) in displayArticles"
          :key="idx"
          class="press-card"
        >
          <!-- 이미지 영역 -->
          <div class="press-image">
            <img
              v-if="article.imageUrl"
              :src="article.imageUrl"
              :alt="article.title"
              class="press-img"
            />
            <div v-else class="press-img-placeholder">
              <file-text-outlined style="font-size: 32px; color: #90caf9;" />
            </div>
          </div>

          <!-- 텍스트 영역 -->
          <div class="press-content">
            <div v-if="article.mediaOutlet" class="press-outlet">
              {{ article.mediaOutlet }}
            </div>
            <h3 class="press-title">{{ article.title }}</h3>
            <p v-if="article.description" class="press-description">
              {{ article.description }}
            </p>
            <span class="press-more">더보기 →</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FileTextOutlined } from '@ant-design/icons-vue';

const DEFAULT_ARTICLES = [
  {
    title: '서티라이프, 디지털 의료 인증서 40만 건 돌파...',
    description: '의료 산업 디지털 전환의 선두주자로 자리매김',
    imageUrl: '',
    linkUrl: '',
    mediaOutlet: '매일경제',
    publishedAt: '',
  },
  {
    title: 'AI 상담으로 병원 상담 혁신...',
    description: 'AI 기반 환자 상담 솔루션으로 업무 효율 극대화',
    imageUrl: '',
    linkUrl: '',
    mediaOutlet: '한국경제',
    publishedAt: '',
  },
  {
    title: '서티라이프·덴티움 제휴... 임플란트 정품 인증...',
    description: '글로벌 임플란트 기업과의 전략적 파트너십 체결',
    imageUrl: '',
    linkUrl: '',
    mediaOutlet: '조선일보',
    publishedAt: '',
  },
];

export default {
  name: 'SectionPress',

  components: {
    FileTextOutlined,
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    displayArticles() {
      if (this.data?.articles && this.data.articles.length) {
        return this.data.articles;
      }
      return DEFAULT_ARTICLES;
    },
  },
};
</script>

<style scoped>
.section-press {
  background: #fafafa;
  padding: 48px 24px;
}

.press-container {
  max-width: 1100px;
  margin: 0 auto;
}

.press-heading {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 32px;
}

.press-cards {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.press-card {
  display: flex;
  gap: 24px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  transition: box-shadow 150ms ease;
}

.press-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.press-image {
  flex: 0 0 280px;
  height: 180px;
  overflow: hidden;
}

.press-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.press-img-placeholder {
  width: 100%;
  height: 100%;
  background: #e3f2fd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.press-content {
  flex: 1;
  padding: 24px 24px 24px 0;
  display: flex;
  flex-direction: column;
}

.press-outlet {
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 8px;
  font-weight: 500;
}

.press-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.4;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.press-description {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  flex: 1;
}

.press-more {
  font-size: 14px;
  color: #1677ff;
  cursor: pointer;
  align-self: flex-end;
}
</style>
